import React, { useState } from "react";
import "./style.css";
import logo from "../../assets/logo.png"; // adapte le chemin si nécessaire
import LangSelect from "../LangSelect";
import { useLang } from "../../context/langProvider";
import { NavLink, useNavigate } from "react-router-dom";
import LoginModal from "../LoginModal"; // importe ton modal
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";
import { capitalizeFullName } from "../../utils/stringUtils";

const Header = () => {
  const { t } = useLang();
  const navigate = useNavigate();
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const handleLogout = () => {
    dispatch(logout());
  };
  return (
    <header className="header">
      <div className="header-main-container">
      {/* Logo */}
      <div className="logo">
        <a href="/">
          <img src={logo} alt="Logo Intereseaux" className="logo-img" />
        </a>
      </div>

      {/* Barre de recherche */}
      <div className="search-bar">
        <input
          type="text"
          placeholder={t("header-placeholder")}
        />
      </div>

      {/* Boutons Auth */}
      <div className="auth-buttons">
        <LangSelect />
        {
          user?(
            <div className="userInfos">
              <span>Bienvenue, {capitalizeFullName(user.firstNameUser)}</span>
              <button onClick={handleLogout}>Se déconnecter</button>
            </div>
          ):(
            <>
            <button onClick={() => navigate("/subscription")}>{t("inscription")}</button>

            <button onClick={() => setIsLoginOpen(true)}>{t("connexion")}</button>
            </>
            
          )
        }
       
      </div>
      </div>
      {
        user&&(
          <div className="menu-user-container">
            <ul>
              {user.roleUser==="admin"&&(
                <NavLink className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              } to={"/adminDashboard"}>MON ESPACE ADMIN</NavLink>
              )}
              <NavLink className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              } to={"/profil"}>MON PROFIL</NavLink>
              <li>PROJETS</li>
              <li>MESSAGERIE</li>
            </ul>
          </div>
        )
      }
      {isLoginOpen && (
        <LoginModal onClose={() => setIsLoginOpen(false)} />
      )}
    </header>
  );
};

export default Header;
